import { makeVar, useReactiveVar } from '@apollo/client';

type SetCanvasNodesDraggable = (isCanvasSelectable: boolean) => void;

const isCanvasSelectableVar = makeVar<boolean>(false);

function setIsCanvasSelectable(isCanvasSelectable) {
  if (isCanvasSelectableVar() !== isCanvasSelectable) {
    isCanvasSelectableVar(isCanvasSelectable);
  }
}

export function useIsCanvasSelectableOperations(): {
  setIsCanvasSelectable: SetCanvasNodesDraggable;
} {
  return { setIsCanvasSelectable };
}

export default function useIsCanvasSelectable(): [
  boolean,
  SetCanvasNodesDraggable,
] {
  const isCanvasSelectable = useReactiveVar(isCanvasSelectableVar);

  return [isCanvasSelectable, setIsCanvasSelectable];
}
